import React, { FC, useCallback, useEffect, useMemo, useState } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import DetailPageHeader from '../detail_page_header/DetailPageHeader';
import {
	getEntityById,
	getStatusLabelFromPipelineFilters,
	nullSafeGet,
	nullSafeGetOrElse,
} from '../../utils/DataAccessUtils';
import { Button, Popconfirm } from 'antd';
import { cycleEventsRestCrudThunksForBuyer } from '../../thunks/cycle_events_thunks';
import GeneralStatusDisplay from '../BuyerAdminCycleEventsIndexPage/GeneralStatusDisplay';
import CycleEventPipeLineFilters from '../BuyerAdminCycleEventsIndexPage/CycleEventPipelineFilters';
import { ACC_RUN_STATUSES } from '../../utils/AssetCycleUtils';
import DateTimeHover from '../date_time_component/DateTime';

interface AssetCycleCountEventDetailPageProps {
	match: any;
	location: any;
	history: any;
	cycleEvent: any;
	cycleRunsFetching: boolean;
	companyConfig: any;
	getCycleEvent(id: number | string): Promise<any>;
	childRoutes: any[];
	deleteCycleEvent(cycleEvent: any): Promise<any>;
}

const AssetCycleCountEventDetailPage: FC<AssetCycleCountEventDetailPageProps> = ({
	match,
	history,
	companyConfig,
	getCycleEvent,
	childRoutes,
	cycleEvent,
	deleteCycleEvent,
}): React.ReactElement => {
	const cycleRunId = useMemo(() => match.params.id, [match.params.id]);

	const defaultPath = '/buyer/admin/cycleevents';

	useEffect(() => {
		getCycleEvent(cycleRunId);
	}, [cycleRunId]);

	const runCounts = nullSafeGetOrElse('assetCycleCountRunCountsBasedOnStatus', cycleEvent, []);
	const completedEntry = runCounts.find(function (c) {
		return c.categoryName === ACC_RUN_STATUSES.READY_FOR_APPROVAL;
	});
	const completedCount = nullSafeGetOrElse('count', completedEntry, 0);
	return (
		<div>
			<DetailPageHeader
				exactPath="/buyer/assetcycleevents/detail/:id"
				redirectPath={`/buyer/assetcycleevents/detail/${cycleRunId}/details`}
				backLinkText={'Back to Asset Cycle Runs'}
				backLinkTo={defaultPath}
				title={nullSafeGet('name', cycleEvent) || ''}
				subtitle={
					<div className="flex flex-row items-center gap-2">
						<GeneralStatusDisplay
							statusKey={nullSafeGet('status', cycleEvent)}
							statusLabel={getStatusLabelFromPipelineFilters(
								CycleEventPipeLineFilters,
								nullSafeGet('status', cycleEvent)
							)}
							className="footnoteDescription"
						/>
						<div className="footnoteregular text-white">
							{completedCount}/{nullSafeGetOrElse('locationCount', cycleEvent, 0)} Runs complete
						</div>
						<div className="footnoteregular text-white">
							Due:{' '}
							<DateTimeHover
								showDate
								timestamp={nullSafeGet('dueAt', cycleEvent)}
								showTime={false}
							/>
						</div>
					</div>
				}
				actions={[
					<Button
						key="edit"
						ghost
						onClick={() => history.push(`/buyer/assetcycleevents/edit/${cycleRunId}`)}
					>
						Edit
					</Button>,
					<Popconfirm
						title="Are you sure you want to delete this asset cycle event?"
						onConfirm={() => deleteCycleEvent(cycleEvent).then(() => history.push(defaultPath))}
					>
						<Button key="delete" ghost className="ml-4">
							Delete
						</Button>
					</Popconfirm>,
				]}
				tabs={[]}
				backgroundColor={nullSafeGet('detail.config.theme.navblock', companyConfig)}
				childRoutes={childRoutes}
			/>
		</div>
	);
};

const mapStateToProps = (state, ownProps) => ({
	cycleEvent: getEntityById(ownProps.match.params.id, state.cycle_events),
	companyConfig: state.company_config,
});

const mapDispatchToProps = (dispatch) => ({
	getCycleEvent: (id) => dispatch(cycleEventsRestCrudThunksForBuyer.readOne(id)),
	deleteCycleEvent: (cycleEvent) => dispatch(cycleEventsRestCrudThunksForBuyer.delete(cycleEvent)),
});

export default withRouter(
	connect(mapStateToProps, mapDispatchToProps)(AssetCycleCountEventDetailPage as any)
);
